import { type DomainAccessControlConfig } from 'domains/retailer-funded-marketing/utils/domain/accessControl'
import { Permission } from 'domains/retailer-funded-marketing/access-control/permissions'
import { Flipper } from 'domains/retailer-funded-marketing/access-control/flippers'

export const retailerFundedMarketingPhaseFourAccessControl: DomainAccessControlConfig = [
  {
    flippers: [Flipper.retailerFundedMarketingPhase4],
    permissions: [
      Permission.RetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingModifyAccess,
    ],
  },
]
